import { scrollingCampaignPage } from "@areas/Core/Views/Pages/ScrollingCampaignPage/xyl.views.scrollingCampaignPage";
import type { XylView } from "../../helpers/xyl-view-helpers";

export const pages: XylView[] = [scrollingCampaignPage];
